/**
 * Urban Inventory Module
 *
 * @version 0.1 — Fase 2A (visualización, solo lectura)
 * @module core/modules/urban-inventory
 *
 * @description
 * Módulo frontend de Inventario Urbano Transversal.
 * Fase 2A: visualización de urban_entities importadas en Fase 1.
 * Sin creación manual, sin pinceles, sin BottomToolbar propia.
 *
 * Auto-registro: este módulo se registra en el moduleRegistry
 * al importarse (side-effect import desde MapLayout.tsx).
 */

import { moduleRegistry } from '../../module-registry';
import { UrbanInventoryTabbedPanel } from './components/UrbanInventoryTabbedPanel';

// Types
// UrbanEntityFilters omitido: mismo nombre que el componente UrbanEntityFilters; usar importación directa desde './types/urban-entity.types' si se necesita como tipo
export type { UrbanEntity, UrbanEntityStatus, UrbanEntitySourceType, UrbanEntityNpaStatus } from './types/urban-entity.types';

// Store
export { useUrbanInventoryStore } from './store/urban-inventory-store';

// Hooks
export { useUrbanEntities } from './hooks/useUrbanEntities';
export { useUrbanEntitiesLayer } from './hooks/useUrbanEntitiesLayer';
export { useUrbanEntityInteractivity } from './hooks/useUrbanEntityInteractivity';

// Components
export { UrbanInventoryTabbedPanel } from './components/UrbanInventoryTabbedPanel';
export { UrbanEntityDetailsPanel } from './components/UrbanEntityDetailsPanel';
export { UrbanEntityAttributesView } from './components/UrbanEntityAttributesView';
export { UrbanEntityList } from './components/UrbanEntityList';
export { UrbanEntityFilters } from './components/UrbanEntityFilters';

// Services
export { urbanEntitiesApi } from './services/urban-entities-api.service';

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

/**
 * Registra el módulo urban-inventory en el registry.
 *
 * @remarks
 * Fase 2A: sin toolbar (no hay pinceles todavía).
 * Sin provider: el panel lee projectId directamente de useProject().
 */
moduleRegistry.register({
  id: 'urban-inventory',
  leftPanel: UrbanInventoryTabbedPanel,
  // toolbar: undefined — Fase 2B lo agregará
  // provider: undefined — no necesario en Fase 2A
  requiresRealtime: false,
  enabledByDefault: true,
});
